// import * as types from './type.js'
export default {
	// imagePreview: (state) => { return state.imagePreview }
}
